// extracted by mini-css-extract-plugin
export default {"main":"product_main__Xmq71"};